import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { helpCenterEventEmitter } from '../utils/event-emitter';
import { useHelpCenterTarget } from './use-help-center-target';

export const useHelpCenter = () => {
  const location = useLocation();
  const { target, setTarget, clearTarget } = useHelpCenterTarget(location.pathname);

  useEffect(() => {
    location.key && clearTarget();
  }, [location.key, clearTarget]);

  useEffect(() => {
    helpCenterEventEmitter.on('open', setTarget);
    helpCenterEventEmitter.on('close', clearTarget);

    return () => {
      helpCenterEventEmitter.off('open', setTarget);
      helpCenterEventEmitter.off('close', clearTarget);
    };
  }, [setTarget, clearTarget]);

  return {
    target,
    clearTarget,
  };
};
